import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import useDataEvents from '../../dataHooks/useDataEvents'
import { LoadingIcon } from '@prosolve/common-components-ui'
import useSnackbar from '../../hooks/useSnackbar'
import useForm from '../../hooks/useForm';
import { FormField, Button } from '@prosolve/common-components-ui'
import { formatDateSpan, getClientSubdomain } from '../../utils'
import FormFieldUsStates from '../../shared/FormFieldUsStates';

export default () => {
  const clientSubdomain = getClientSubdomain()
  const isStarSubdomain = (clientSubdomain === 'star')

  const { shareCode = '' } = useParams();
  const [ ...codeArray ] = shareCode;
  // Remove first destinationChar which is unused in our logic
  codeArray.shift()
  const code = codeArray.join('');

  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');

  const { fetchEventIdByCode } = useDataEvents();
  const snackbar = useSnackbar()

  const [isLoading, setIsLoading] = useState(true)
  const [eventData, setEventData] = useState()
  const [isSubmissionSuccess, setIsSubmissionSuccess] = useState(false)

  const {
    startDate,
    endDate
  } = eventData || {}

  const {
    isLoading: isLoadingDataEvents,
    fetchEvent,
    updateEvent,
    validateShareLogistics,
    fetchValidateShareLogistics,
  } = useDataEvents();

  const showError = (message) => {
    snackbar.newMessage({ message, severity: 'failure' })
  }

  const fetchEventDataByCode = async (code) => {
    setIsLoading(true)
    try {
      const { eventId } = await fetchEventIdByCode(code) || {}
      const eventData = await fetchEvent(eventId) || {}
      setEventData(eventData)
    } catch (e) {
      console.log(e)
      showError('Error occured')
      setEventData()
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (code) {
      fetchEventDataByCode(code)
    }
    if (key) {
      fetchValidateShareLogistics({key})
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, key])

  const onSubmit = async (data) => {
    if (!isLoading) {
      setIsLoading(true)

      try {
        const submitData = { ...data, id: eventData.id }
        await updateEvent(submitData)
        setIsSubmissionSuccess(true)
      } catch (e) {
        console.log(e)
      } finally {
        setIsLoading(false)
      }
    }
  }

  const EventForm = ({
    eventData,
    onSubmit: onSubmitParam
  }) => {
    const optionalFields = ['addressStreet', 'addressCity', 'addressState', 'addressZip', 'additionalLocationNotes', 'projectHandoutsLink'];
    if (isStarSubdomain) {
      optionalFields.push('numberOfParticipants')
    }

    const formSchema = {
      requiredFields: ['name'],
      optionalFields,
      initData: eventData
    };

    const formData = useForm(formSchema)

    const onSubmit = () => {
      if (formData.isValid()) {
        onSubmitParam?.(formData.values)
      }
    }

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px',
        width: '50%'
      }}>
        <div>
          <div style={{ color: '#565656', fontWeight: 'bold', fontSize: '14px', marginBottom: '10px' }}>
            Event Date
          </div>
          <div style={{ color: '#565656', fontSize: '14px', margin: '10px' }}>
            {formatDateSpan(startDate, endDate)}
          </div>
          <div style={{ color: '#565656', fontWeight: 'bold', fontSize: '14px', marginBottom: '10px' }}>{'Address'}</div>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: '15px',
            background: '#fdfdfd',
            border: '1px solid #dedede',
            borderRadius: '5px',
            padding: '13px'
          }}>
            <FormField
              style={{ flex: 1 }}
              fieldId='addressStreet'
              type='text'
              label='Street'
              placeholder=''
              formData={formData}
            />
            <FormField
              style={{ flex: 1 }}
              fieldId='addressCity'
              type='text'
              label='City'
              placeholder=''
              formData={formData}
            />
            <FormFieldUsStates
              style={{ flex: 1 }}
              fieldId='addressState'
              label='State'
              placeholder=''
              formData={formData}
              width='100%'
              maxHeight='300px'
            />
            <FormField
              style={{ flex: 1 }}
              fieldId='addressZip'
              type='text'
              label='Zip'
              placeholder=''
              formData={formData}
            />
          </div>
        </div>
        <FormField
          style={{ flex: 1 }}
          fieldId='additionalLocationNotes'
          type='text'
          label="Additional Location Notes"
          placeholder=''
          formData={formData}
        />
        {isStarSubdomain &&
          <FormField
            style={{ flex: 1 }}
            fieldId='numberOfParticipants'
            type='number'
            label="Number Of Participants"
            placeholder=''
            formData={formData}
          />
        }
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          columnGap: '10px',
          padding: '10px'
        }}>
          <Button onClick={onSubmit} $colored={true} $disabled={isLoading}>
            {'Submit'}
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      marginTop: '50px'
    }}>
      {
        !key
          ?
        <div>This link is missing the authentication key. A key is required to access this resource.</div>
          :
        !validateShareLogistics?.success
          ?
        <div>This link has expired.</div>
          :
          isLoading || isLoadingDataEvents
            ?
          <LoadingIcon />
            : 
            isSubmissionSuccess
              ?
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: '15px',
              textAlign: 'center'
            }}>
              <div style={{ fontWeight: 'bold', fontSize: '32px'}}>{'Thank You!'}</div>
              <div style={{ marginTop: '50px', fontSize: '32px'}}>{'You have successfully updated this event!'}</div>
              <div style={{ marginTop: '50px', fontSize: '20px' }}>{'You may now close this window.'}</div>
            </div>
              :
              !Boolean(eventData) 
                ?
              <div>
                {'Unable to find associated event'}
              </div>
                :
                <EventForm eventData={eventData} onSubmit={onSubmit} />
      }
    </div>
  )
}